import React from 'react';
import Modal from "react-bootstrap/Modal";
import {Nav} from "react-bootstrap";
import parse from 'html-react-parser';

export default class NavGdprComponent extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            show: false
        };
    }


    handleClose = () => {
        this.setState({show: false});
    };

    openModal = () => {
        this.setState({show: true});
    };

    render() {
        let {show} = this.state;
        if (!this.props.gdpr) {
            return null;
        }
        return (
            <Nav.Item style={{ flexShrink: 1 }}>
                <Nav.Link onClick={this.openModal} title={this.props.gdpr.title.length > 30 && this.props.gdpr.title}>
                    <i className="fa fa-fw fa-info-circle"/>
                    {this.props.gdpr.title.length > 30 ? this.props.gdpr.title.substr(0,27)+'...' : this.props.gdpr.title}
                </Nav.Link>
                <Modal show={show} onHide={this.handleClose} animation={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.props.gdpr.title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{this.props.gdpr.content ? parse(this.props.gdpr.content) : ''}</Modal.Body>
                </Modal>
            </Nav.Item>
            );

    }
}
